export default class Drag {
	constructor() {
		this.mouseDrag = null;
		this.touches = {};
		this.cells = new Map();
		document.body.addEventListener('mouseleave', () => {
			this.end(null, this.mouseDrag);
			this.mouseDrag = null;
		});
		document.body.addEventListener('touchend', this.endTouch(null));
		document.body.addEventListener('touchcancel', this.endTouch(null));
		document.body.addEventListener('touchmove', e => {
			for (const touch of e.changedTouches) {
				const copy = this.touches[touch.identifier];
				if (!copy) continue;
				const packet = this.getPacketForTouch(touch);
				if (!packet) return;
				if (copy.lastCell != packet) {
					this.move(packet, copy);
					copy.lastCell = packet;
				}
			}
		});
	}

	getPacketForTouch(touch) {
		for ( // NOTE: "client" might be the wrong coords, haven't tested with scrolling
			let el = document.elementFromPoint(touch.clientX, touch.clientY);
			el;
			el = el.parentElement
		) {
			const packet = this.cells.get(el);
			if (packet) return packet;
		}
	}

	endTouch(packet) {
		return e => {
			for (const touch of e.changedTouches) {
				const copy = this.touches[touch.identifier];
				if (!copy) continue;
				this.end(packet, copy);
				delete this.touches[touch.identifier];
			}
		};
	}

	// override these
	start(cell, drag) {}
	end(cell, drag) {}
	move(cell, drag) {}

	registerCell(el, packet) {
		this.cells.set(el, packet);
		el.addEventListener('mousedown', () => {
			this.mouseDrag = {};
			if (this.mouseDeadUntil > Date.now()) return;
			this.start(packet, this.mouseDrag);
		});
		el.addEventListener('mouseenter', () => {
			if (this.mouseDrag) this.move(packet, this.mouseDrag);
		});
		el.addEventListener('mouseup', () => {
			if (this.mouseDrag) this.end(packet, this.mouseDrag);
			this.mouseDrag = null;
		});
		el.addEventListener('touchstart', e => {
			this.mouseDeadUntil = Date.now() + 300;
			for (const touch of e.changedTouches) {
				const copy = { ...touch, lastCell: packet };
				if (this.start(packet, copy) !== false)
					this.touches[touch.identifier] = copy;
			}
		});
		el.addEventListener('touchend', this.endTouch(packet));
		el.addEventListener('touchcancel', this.endTouch(packet));
	}

	removeListeners() {
		// TODO: this really should exist
	}
}
